"use client"

import { Button } from "@/components/ui/button"
import { User, Building2 } from "lucide-react" // Import icons

interface WelcomeUserTypeScreenProps {
  onNext: () => void;
  updateUserData: (data: { userType: string }) => void;
  // Add other props like existing user data if needed for pre-filling
}

export default function WelcomeUserTypeScreen({
  onNext,
  updateUserData,
}: WelcomeUserTypeScreenProps) {
  const handleUserTypeSelection = (userType: string) => {
    updateUserData({ userType })
    onNext()
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-center">
          Welcome to BraidPay!
        </h1>
        <p className="text-sm text-gray-600 mt-2 text-center">
          Let's get your account set up. <br /> Please tell us if you are
          signing up as an individual or for a business.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4">
        <Button
          variant="outline"
          className="w-full h-auto py-6 flex flex-col items-center justify-center space-y-2 text-base hover:bg-gray-50"
          onClick={() => handleUserTypeSelection("INDIVIDUAL")}
          data-testid="individual-user-type-button"
        >
          <User className="h-10 w-10 mb-2 text-blue-600" />
          <span>I'm an Individual</span>
        </Button>
        <Button
          variant="outline"
          className="w-full h-auto py-6 flex flex-col items-center justify-center space-y-2 text-base hover:bg-gray-50"
          onClick={() => handleUserTypeSelection("BUSINESS")}
          data-testid="business-user-type-button"
        >
          <Building2 className="h-10 w-10 mb-2 text-blue-600" />
          <span>I'm a Business</span>
        </Button>
      </div>
    </div>
  )
}
